import { render, staticRenderFns } from "./FotoPendukung.vue?vue&type=template&id=26dbe405&"
import script from "./FotoPendukung.vue?vue&type=script&lang=js&"
export * from "./FotoPendukung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports